import { isProd } from './util';

export const devServers = ['dkatest-prn1', 'dkatest-prn2', 'czatest-prn1', 'czatest-prn2'] as const;
export const czPackingDevServers = ['czatest-prn1', 'czatest-prn2'] as const;
export const czPackingProdServers = ['czaapp-prn3', 'czaapp-prn4'] as const;
export const cnPackingProdServers = ['cnaapp-prn3', 'cnaapp-prn4'] as const;
export const huPackingProdServers = ['huaapp-prn3', 'huaapp-prn4'] as const;
export const mxPackingProdServers = ['mxaapp-prn3', 'mxaapp-prn4'] as const;
export const packingProdServers = [
  ...czPackingProdServers,
  ...cnPackingProdServers,
  ...huPackingProdServers,
  ...mxPackingProdServers,
] as const;
export const prodServers = [
  'dkaapp-prn1',
  'dkaapp-prn2',
  'czaapp-prn1',
  'czaapp-prn2',
  ...czPackingProdServers,
  'huaapp-prn1',
  'huaapp-prn2',
  ...huPackingProdServers,
  'cnaapp-prn1',
  'cnaapp-prn2',
  ...cnPackingProdServers,
  'mxaapp-prn1',
  'mxaapp-prn2',
  ...mxPackingProdServers,
  'vnaapp-prn1',
  'vnaapp-prn2',
  'usaapp-prn1',
  'usaapp-prn2',
  'usaapp-prn3',
  'usaapp-prn4',
] as const;

export const getServers = () => (isProd() ? prodServers : devServers);
export const getCzPackingServers = () => (isProd() ? czPackingProdServers : czPackingDevServers);

export type ServerName = (typeof devServers)[number] | (typeof prodServers)[number];
